import React, { memo } from 'react'
import * as Types from 'apps/fleet-planner/types'
import { Bullet } from 'components/atoms'
import formatPhone from 'utils/formatPhone'

interface IContactDisplayTileProps {
  contact: Types.ICustomerContact | undefined
}

export const ContactDisplayTile = memo<IContactDisplayTileProps>(({ contact }) => {
  const { email, name, phone, phoneExt } = contact || {}
  return (
    <div className='rounded bg-secondary mb4 pa4'>
      <div>{name ?? 'No contact name'}</div>
      <div className='fs-mask'>
        {email ? <span>{email}</span> : <span>No contact email</span>}
        <Bullet />
        {phone ? (
          <span className='fs-mask'>
            {formatPhone(phone, {
              removeCountryCode: '+1',
            })}
          </span>
        ) : (
          <span>No contact phone</span>
        )}
        {phoneExt && <span className='dib'>&nbsp;{`ext ${phoneExt}`}</span>}
      </div>
    </div>
  )
})
